import type { PickerImage } from "components/SignageEditOrder/types";

/** UI images > variant images > product images */
export function pickImages(
  selectedVariant: any,
  productObj: any,
  imagesFromUI?: PickerImage[]
) {
  if (imagesFromUI?.length) return imagesFromUI;
  if (selectedVariant?.images?.length) return selectedVariant.images;
  return productObj?.product?.images ?? [];
}

export const n = (v: any) => Number(v || 0);

export const r2 = (v: any) => Math.round(n(v) * 100) / 100;

/** New unique ID for custom product/variant rows */
export async function fetchNewUniqueId(token: string): Promise<string> {
  const url = `${process.env.REACT_APP_API_URL}/utils/new-unique-id`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(errorData.message || `Failed to fetch unique ID: ${res.statusText}`);
  }
  const data = await res.json().catch(() => ({}));
  const id = data?.id || data?.data?.id || data?.data?.unique_id || data?.unique_id || null;
  if (!id) throw new Error("Unique ID not found in API response");
  return String(id);
}
